import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { useRestoreCasDispositionTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { useDispositionTypesContext } from '../../DispositionTypesContext'
import { CASDispositionType } from '../../DispositionTypesContext/types'

export function useRestore(): RestoreRowActionOptions<CASDispositionType> {
  const { refetch } = useDispositionTypesContext()
  const [restore] = useRestoreCasDispositionTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreCASDispositionType: {
        dispositionType: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreCASDispositionType,
    metadata: ({ deleted, deletedDate, deletedUser }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      refetch()
    },
    default: 'active',
  }
}
